// src/pages/ProductsPage.js
import React from 'react';
import ProductGrid from '../components/Products/ProductGrid';
import { Container } from 'react-bootstrap';
import '../styles/products.css';

const ProductsPage = () => {
    return (
        <Container className="products-page">
            <h1 className="ff-heading-h1">All Products</h1>
            <ProductGrid />
        </Container>
    );
};

export default ProductsPage;